import { fetchContent } from "../services/api";

function handleViewAll(data) {
  console.log("debug 1102 Should Come Once before Data :: ", data);
  let viewAllDataObj_template = {
    type_id: "view_all",
    title: "View All",
    detail_banner: "",
    poster_url: "",
    file_url: "",
  };

  const updatedData = data.map((row) => {
    if (
      row.restrict_view_all === 0 &&
      row.list &&
      row.list.length > 0 &&
      row.list[row.list.length - 1].id !== "view_all"
    ) {
      let viewAllDataObj = row;
      viewAllDataObj = {
        ...viewAllDataObj,
        ...viewAllDataObj_template,
        ...{list:null}
      };
       
      return {
        ...row,
        list: [...row.list, viewAllDataObj],
      };
    }
    return row;
  });

  return updatedData;
}

// function getViewAllContent(data, playlist_name, pageNumber = 1) {
//   console.log("getLiveEvents Data.......", data.playlist_type, playlist_name, data);
//   const user_details = JSON.parse(localStorage.getItem("user_details"));
//   const userId = localStorage.getItem("profileId");
//   const getCountry = localStorage.getItem("country");

//   let myHeaders = {
//     platform: "0",
//     iskid: "0",
//     isDefault: "0",
//     country: getCountry,
//     age: "12",
//     Authorization: `Bearer ${localStorage.getItem("JWTToken")}`,
//     "Content-Type": "application/json",
//   };

//   let fetchContentPromise;
//   let TagId;
//   let URL = "";

//   if (data.playlist_type_id === 19 || data.playlist_type === "genres") {
//     TagId = data.tag_id;
//     URL = `/V1/getHomeContent/0?tag_id=${TagId}&publisher_id=${data.publisher_id}&playlist_id=${data.id}&page=${window.PAGE_INDEX}`;
//     console.log("datamanager....genres...");
//   } else {
//     TagId = data.category_id !== null ? data.category_id : data.id;
//     if (data.publisher_id === null) {
//       URL = `/V1/getHomeContent/0?category_id=${TagId}&page=${pageNumber}`;
//     } else {
//       if (TagId === 0) {
//         URL = `/V1/getHomeContent/0?category_id=&page=${pageNumber}`;
//       } else {
//         URL = `/V1/getHomeContent/0?category_id=${TagId.toString()}&publisher_id=${data.publisher_id}&page=${pageNumber}`;
//       }
//     }
//   }

//   try {
//     fetchContentPromise = fetchContent(URL, "GET", myHeaders);
//     fetchContentPromise.then(function (viewAllData) {
//       console.log("Pagination Result:", viewAllData, URL);
//     }).catch(function () {
//       console.log("fetchContentPromise Catch");
//     });
//   } catch (error) {
//     console.error("Error fetching data:", error);
//   }

//   return fetchContentPromise;
// }


function getViewAllContent(data, playlist_name, localPageNumber) {
    console.log("getLiveEvents Data.......", data.playlist_type, playlist_name, data, localPageNumber);
    const user_details = JSON.parse(localStorage.getItem("user_details"));
    const userId = localStorage.getItem("profileId");
    const getCountry = localStorage.getItem("country");
    const pageNumber = localPageNumber ? localPageNumber : 1;
    let myHeaders = {
      // event: "",
      // category_id: "",
      // genres: "",
      // genres_ids: "",
      // tag_id: "",
      // is_trending: "",
      // is_home_page: "",
      // page: "",
      // content_language_id: "",
      // publisher_id: "",
      // layout: "",

      // is_home_page: "1",
      platform: "0",
      iskid: "0",
      isDefault: "0",
      country: getCountry,
      age: "12",
      // Langid: "1",
      // devicetype: "11",
      // profileid: userId,
      Authorization: `Bearer ${localStorage.getItem("JWTToken")}`,
      "Content-Type": "application/json",
  };
  let fetchContentPromise;
  let TagId;
  let URL = "";

  // if(data.playlist_type_id === 19 || data.playlist_type_id === 11){

  //     TagId = data.tag_id;
  //     URL = `/V1/getHomeContent/0?playlist_id=${data.id}&tag_id=${TagId}&page=1`;
  //     console.log("datamanger....444444444..........", data,playlist_name);
     if(data.playlist_type_id === 8){
      TagId = data.genres_id;
      URL = `/V1/getHomeContent/0?publisher_id=${data.publisher_id}&genres=${TagId}&page=${pageNumber}`;
      console.log("datamanger....444444444..........", data,playlist_name);
    }else if(data.playlist_type_id === 19){
        TagId = data.tag_id;
        URL = `/V1/getHomeContent/0?playlist_id=${data.id}&tag_id=${TagId}&page=${pageNumber}`;
        console.log("datamanger....444444444..........", data,playlist_name);
    }
    // if(data.playlist_type_id === 19 || data.playlist_type === "genres"){
    //   TagId = data.tag_id;
    //   // URL = `/V1/getHomeContent/0?tag_id=${TagId}&publisher_id=${data.publisher_id}&playlist_id=${data.id}&page=1`;
    //   console.log("datamanger....444444444..........");
    // }
    // else if(data.playlist_type === "live"){
    //   TagId = data.category_id;
    //   URL = `/V1/getLiveSection/0?tag_id=${TagId}&publisher_id=0&playlist_id=78&page=1`;
    // } 
 
    else {
      console.log("datamanager.........3333333333.........");
      // TagId = data.tag_id;
      TagId = data.category_id !== null ? data.category_id : data.id;
      if(data.publisher_id === null){
      URL = `/V1/getHomeContent/0?category_id=${TagId}`;
      console.log("line 85....", TagId, URL);
    } else {
      console.log("datamanager.....");
       if(TagId === 0) {
        TagId = "";
        URL = `/V1/getHomeContent/0?category_id=${TagId}`;
        console.log("line 89....", TagId, URL);
       } 
       else {
        TagId = data.category_id !== null ? data.category_id : data.id;
        URL = `/V1/getHomeContent/0?category_id=${TagId.toString()}&playlist_id=${data.id}`;
        console.log("line 93....", TagId, URL, data);
       }
    }
    }
    try {
      fetchContentPromise = fetchContent(URL, "GET", myHeaders);
      fetchContentPromise.then(function (viewAllData) {
        console.log("fetchContentPromise then",viewAllData, URL)
      });
      fetchContentPromise.catch(function () {
        console.log("fetchContentPromise Catch");
      });
    } catch (error) {
      console.error("Error fetching data:", error);
    }
    return fetchContentPromise;
};

  function getlanguagepopular(data, playlist_name, localPageNumber) {
    console.log("getLiveEvents Data.......", data.playlist_type, playlist_name, data);
    const user_details = JSON.parse(localStorage.getItem("user_details"));
    const userId = localStorage.getItem("userId");
    const getCountry = localStorage.getItem("country");
    const pageNumber = localPageNumber ? localPageNumber : 1;
    let myHeaders = {
      platform: "0",
      iskid: "0",
      isDefault: "0",
      country: getCountry,
      age: "100",
      Langid: "1",
      
      profileid: userId,
      Authorization: `Bearer ${localStorage.getItem("JWTToken")}`,
      "Content-Type": "application/json",
  };
  let fetchContentPromise;
  let TagId;
  let URL = "";
     if(data.playlist_type_id === 10){
      TagId = playlist_name.id;
      let playlist_id = data.playlist_id ? data.playlist_id : "";
      // https://api.wavespb.com/api/V1/getHomeContent/0?playlist_id=&genres=80&page=1
      // ?genres=\(genres)&publisher_id=\(self.publisherId)&page=\(self.currentPage)
      URL = `/V1/getHomeContent/0?&playlist_id=${playlist_id}&genres=${TagId}&page=${pageNumber}`;
      console.log("datamanger....444444444..........", data,playlist_name);
    } else if(data.playlist_type_id === 9){
      TagId = playlist_name.id;
      let playlist_id = data.playlist_id ? data.playlist_id : "";
      // https://api.wavespb.com/api/V1/getHomeContent/0?content_language_id=1&page=1&playlist_id=
 
      // "?content_language_id=\(genres)&publisher_id=\(self.publisherId)&page=\(self.currentPage)
      // ?genres=\(genres)&publisher_id=\(self.publisherId)&page=\(self.currentPage)
      URL = `/V1/getHomeContent/0?content_language_id=${TagId}&page=${pageNumber}&playlist_id=${playlist_id}`;
      console.log("datamanger....444444444..........", data,playlist_name);
    }
    try {
      fetchContentPromise = fetchContent(URL, "GET", myHeaders);
      fetchContentPromise.then(function (viewAllData) {
        console.log("fetchContentPromise then",viewAllData, URL)
      });
      fetchContentPromise.catch(function () {
        console.log("fetchContentPromise Catch");
      });
    } catch (error) {
      console.error("Error fetching data:", error);
    }
    return fetchContentPromise;
  };


//   const PaginationData = async (griddata) => {
//     console.log("PaginationData....", griddata);
//     const getCountry = localStorage.getItem("country");

//     let myHeaders = {
//         platform: "0",
//         iskid: "0",
//         age: "12",
//         country: getCountry,
//         isDefault: "1",
//         
//         Authorization: `Bearer ${localStorage.getItem("JWTToken")}`,
//         "Content-Type": "application/json",
//     };

//     try {
//         // Fetch data for each grid item and append new data to `list`
//         const fetchPromises = griddata.map(async (row) => {
//             if (!row.page) {
//                 row.page = 2; // Start from page 2 if undefined
//             }else{
//                 row.page = row.page;
//             }

//             try {
//                 const response = await fetchContent(
//                     `/V1/getplaylistVideo/playlist/${row.id}/platform/0/page/${row.page}`,
//                     "GET",
//                     myHeaders
//                 );

//                 console.log("Response:", response);

//                 // Ensure `list` exists and is an array
//                 const updatedList = Array.isArray(row.list) ? [...row.list, ...response.data] : response.data;

//                 console.log("Updated List:", updatedList);

//                 return {
//                     ...row,
//                     page: row.page + 1, // Increment page for next request
//                     list: updatedList,  // Append new data to the list
//                 };
//             } catch (error) {
//                 console.error(`Error fetching data for playlist ${row.id}:`, error);
//                 return { ...row, page: row.page }; // Return row without modification on error
//             }
//         });

//         // Await all API requests
//         const paginationResponses = await Promise.all(fetchPromises);

//         console.log("Fetched Data:", paginationResponses);
//         return paginationResponses;

//     } catch (error) {
//         console.error("Error fetching data:", error);
//         return []; // Return an empty array on failure
//     }
// };

//   const PaginationData = async (griddata) => {
//     console.log("PaginationData....", griddata);
//     const getCountry = localStorage.getItem("country");

//     let myHeaders = {
//         platform: "0",
//         iskid: "0",
//         age: "12",
//         country: getCountry,
//         isDefault: "1",
//         
//         Authorization: `Bearer ${localStorage.getItem("JWTToken")}`,
//         "Content-Type": "application/json",
//     };

//     try {
//         // Fetch data for each grid item and append new data to `list`
//         const fetchPromises = griddata.map(async (row) => {
//             const page = 2; // Default to page 1 if not set on the row

//             try {
//                 const response = await fetchContent(
//                     `/V1/getplaylistVideo/playlist/${row.id}/platform/0/page/${page}`,
//                     "GET",
//                     myHeaders
//                 );

//                 console.log("Response:", response);

//                 // Ensure `list` exists and is an array
//                 const updatedList = Array.isArray(row.list) ? [...row.list, ...response.data] : response.data;

//                 console.log("Updated List:", updatedList);

//                 return {
//                     ...row,
//                     page: page + 1, // Increment page for next request
//                     list: updatedList,  // Append new data to the list
//                 };
//             } catch (error) {
//                 console.error(`Error fetching data for playlist ${row.id}:`, error);
//                 return { ...row, page: page }; // Return row without modification on error
//             }
//         });

//         // Await all API requests
//         const paginationResponses = await Promise.all(fetchPromises);

//         console.log("Fetched Data:", paginationResponses);
//         return paginationResponses;

//     } catch (error) {
//         console.error("Error fetching data:", error);
//         return []; // Return an empty array on failure
//     }
// };

const PaginationData = async (griddata, page = 2) => {
  console.log("PaginationData....", griddata);
  const getCountry = localStorage.getItem("country");

  let myHeaders = {
    platform: "0",
    iskid: "0",
    age: "12",
    country: getCountry,
    isDefault: "1",
    
    Authorization: `Bearer ${localStorage.getItem("JWTToken")}`,
    "Content-Type": "application/json",
  };

  try {
    const response = await fetchContent(
      `/V1/getplaylistVideo/playlist/${griddata.id}/platform/0/page/${page}`,
      "GET",
      myHeaders
    );

    console.log(`Response for row ${griddata.id} (Page ${page}):`, response.data);

    if (response.data && Array.isArray(response.data)) {
      // Return a new row object with the updated list
      return {
        ...griddata,
        list: [...griddata.list, ...response.data],
      };
    } else {
      console.log("No data found for row", griddata.id);
      return griddata;
    }
  } catch (error) {
    console.error(`Error fetching data for playlist ${griddata.id}:`, error);
    return griddata;
  }
};



  
  
export { handleViewAll ,getViewAllContent, PaginationData, getlanguagepopular};
